<template>
  <li :class="{ open: openIds.has(category.id), active: activeId === category.id }">
    <router-link :to="itemUrl">
      <div
        class="kb-category-menu-option"
        :data-id="category.id"
        @click="() => onClickCategory(category.id)"
      >
        <span
          class="kb-category-menu-option__color-bar"
          style="background-color: #0584cc;"
        />
        {{ category.name }}
      </div>

      <div v-if="!parentId">
        <svg
          width="12"
          height="7"
          xmlns="http://www.w3.org/2000/svg"
          @click.prevent="onToggleDropdown"
        >
          <path
            d="M10.6817 1.6816l-4.5364 4-4.5364-3.9315"
            stroke="#0584cc"
            stroke-width="2"
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </router-link>
    <ul>
      <SidebarItem
        v-for="subCategory in category.subcategories"
        :key="subCategory.id"
        :data-id="subCategory.id"
        :category="subCategory"
        :parent-id="category.id"
      />
    </ul>
  </li>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SidebarItem',
  components: {
  },
  props: {
    parentId: {
      type: Number,
      default: 0
    },
    category: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      title: '',
      faq_categories: [],
    }
  },
  computed: {
    ...mapGetters(['openIds','activeId']),
    itemUrl() {
      if (this.parentId) {
        return `/category/${this.parentId}#${this.category.id}`
      }
      return `/category/${this.category.id}`
    },
  isActive() {return this.$route.fullPath == this.itemUrl},
  },
  mounted() {
    const { categoryId } = this.$route.params

    if(this.$route.hash){
      const id = Number(this.$route.hash.replace('#',''))
      this.setActiveId(id)
    }else if(categoryId) {
      this.setActiveId(Number(categoryId))
    }

    if (!this.parentId) {
      if (categoryId == this.category.id) {
        this.setOpenIds(new Set([Number(categoryId)]))
      }else if(this.$route.query?.category){
        this.setOpenIds(new Set([Number(this.$route.query?.category)]))
      }
    }
  },
  methods: {
    ...mapMutations(['setOpenIds','setActiveId']),
    onClickCategory(id) {
      this.setActiveId(id)

      if (this.parentId) {
        this.setOpenIds(new Set([this.parentId]))
      }else{
        this.setOpenIds(new Set([id]))
      }
    },
    onToggleDropdown() {
      const openIds = new Set(this.openIds)

      if (openIds.has(this.category.id)) {
        openIds.delete(this.category.id)
      } else {
        openIds.add(this.category.id)
      }

      this.setOpenIds(openIds)
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
